import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_TESTS_URL;

export default {
  getTest(code) {
    return $axios.get(`api/v1/test/${code}`, { baseURL: baseUrl });
  },
  submitTest(result) {
    return $axios.post(
      `api/v1/test/${result.testId}/student/${result.studentId}`,
      result,
      { baseURL: baseUrl },
    );
  },
};



// WEBPACK FOOTER //
// ./src/api/tests.js